import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import { Form } from "react-bootstrap";
// import MainChart from "./MainChart";
import Select from "react-select";
import Orange_Btn from "../../../common/buttons/orange_btn/Orange_Btn";
import "./Dashboard.css";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import Reply_Modal from "./Reply_Modal";
import SuccessModel from "../../../common/model/SuccessModel";
import { useDispatch, useSelector } from "react-redux";
import { dashboard, GETAuthLogin } from "../../../features/auth/Slice";
import { getUserQr } from "../../../features/admin/whatsapp/qr/qrSlice";
import {
  GetAllReceivedMessageReports,
  ReplyMessageAction,
  sendMessageAction,
} from "../../../features/admin/whatsapp/message/slice";
import ErrorModel from "../../../common/model/ErrorModel";
import { formatDate } from "../../../utils/common";
import { FixIDS } from "../../../utils/fixIDS";
import ModelLoader from "../../../common/loader/ModelLoader";

const Dashboard = () => {
  const {
    control,
    register,
    reset,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  const [loader, setLoader] = useState(false);
  const [title, setTitle] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [show, setShow] = useState(false);
  const [instanceValue, setInstanceValue] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const options = [];

  const data = [
    {
      name: "H Kamble",
      msg: "Thank you",
      date: "2025-04-09 20:23:57",
    },
    {
      name: "Disha",
      msg: "Admin idde?",
      date: "2025-04-04 18:23:33",
    },
    {
      name: "H Kamble",
      msg: "Yak cl madidde nine?",
      date: "2025-04-09 20:23:57",
    },
    {
      name: "H Kamble",
      msg: "Oyee",
      date: "2025-04-09 20:23:57",
    },
  ];

  const dispatch = useDispatch();

  const dashInfo = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(GETAuthLogin());
    dispatch(dashboard());
  }, []);

  options.push(instanceValue);

  const [time, setTime] = useState("");

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const datePart = now.toLocaleDateString("en-US"); // 8/25/2025
      const timePart = now.toLocaleTimeString("en-US"); // 11:24:31 AM
      setTime(`${datePart} - ${timePart}`);
    };

    updateClock(); // run immediately
    const interval = setInterval(updateClock, 1000); // update every second

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  useEffect(() => {
    setInstance();
  }, [dispatch]);

  const setInstance = async () => {
    const res = await dispatch(getUserQr());
    const data = res?.payload?.data?.data;

    if (Array.isArray(data) && data.length > 0) {
      const options = data?.map((item) => ({
        name: "instance_key",
        value: item?.instance_key,
        label: `${item?.instance_key} -> WP NO : ${item?.contact_no ?? "N/A"} (${item?.instance_status ? "ACTIVE" : "IN-ACTIVE"})`,
      }));

      setInstanceValue(options); // sets array of all instances
    }
  };

  const sendMessage = async (data) => {
    setLoader(true);
    setTitle("Sending Message...");

    console.log("Form Data:", data);

    const sendData = new FormData();

    // Basic fields
    sendData.append("instance_key", data?.instance_key?.value || "");
    sendData.append("to_sent", data?.to_sent || "");
    sendData.append("message", data?.message || "");

    // Media file
    if (data?.media_file && data.media_file.length > 0) {
      sendData.append("media_file", data.media_file[0]);
      sendData.append("combination_id", 2 || "");
    } else {
      sendData.append("combination_id", 1 || "");
    }

    try {
      // Example dispatch:
      const res = await dispatch(sendMessageAction(sendData));
      if (res.meta?.requestStatus === "fulfilled") {
        setLoader(false);
        setShowSuccess(true);
        setShowError(false);
        reset();
        setTitle("");
        await dispatch(dashboard());
      } else if (res.meta?.requestStatus === "rejected") {
        setLoader(false);
        setTitle("");
        setErrorMessage(res.payload?.errors || "Something went wrong");
        setShowError(true);
        setShowSuccess(false);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  const report = useSelector((state) => state.whatsapp.reports);

  useEffect(() => {
    dispatch(
      GetAllReceivedMessageReports({
        per_page: report?.per_page,
      }),
    );
  }, []);

  const Permissions = useSelector((state) => state.auth.permissions);
  const user = useSelector((state) => state.auth.data);
  useEffect(() => {
    dispatch(GETAuthLogin());
  }, [dispatch]);

  return (
    <section className="Dashboard">
      {/* <WidgetsDropdown className="mb-4" /> */}

      <div className="welcome_div">
        <p className="welcome_text">
          Welcome,{" "}
          <span className="bold_text">
            {dashInfo?.data?.username || dashInfo?.data?.name || "Unknown"}
          </span>
        </p>
        <p className="white_txt">
          Login IP Address : {dashInfo?.data?.login_ip}
        </p>
        <p className="white_txt">{time}</p>
      </div>
      {Permissions?.includes(FixIDS?.Tenant.List) ? (
        <>
          <div className="row">
            <div className="col-lg-6">
              <div className="common_white_card quick_msg">
                <div className="heading_div">
                  <p className="heading_text">Quick Message Send</p>
                </div>

                <div className="content_div">
                  <Form>
                    <Form.Group className="input_group common_form_group">
                      <Form.Label>Select Instance From Below List</Form.Label>
                      <Controller
                        name="instance_key" // name of the field
                        defaultValue={{
                          value: 0,
                          label: "---Select Instance---",
                        }}
                        {...register("instance_key", {
                          required: "Select Instance",
                        })}
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.instance_key
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={instanceValue}
                          />
                        )}
                      />
                      {errors?.instance_key && (
                        <Form.Text className="text-danger">
                          {errors?.instance_key?.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <Form.Group className="input_group common_form_group">
                      <Form.Control
                        placeholder="Enter Number with Country Code"
                        type="text"
                        {...register("to_sent", {
                          required: "Number is required",
                          maxLength: {
                            value: 100,
                            message: "Number cannot exceed 100 characters",
                          },
                        })}
                      />
                      {errors?.to_sent && (
                        <Form.Text className="text-danger">
                          {errors?.to_sent?.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <Form.Group className="input_group common_form_group">
                      <Form.Control
                        placeholder="Enter Message"
                        type="text"
                        {...register("message", {
                          required: "Message is required",
                          maxLength: {
                            value: 100,
                            message: "Message cannot exceed 100 characters",
                          },
                        })}
                      />
                      {errors?.message && (
                        <Form.Text className="text-danger">
                          {errors?.message?.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <Form.Group className="input_group common_form_group">
                      <Form.Control
                        placeholder="Enter Message"
                        type="file"
                        {...register("media_file", {
                          validate: {
                            fileSize: (fileList) =>
                              !fileList[0] ||
                              fileList[0].size <= 1 * 1024 * 1024 ||
                              "Max file size is 1MB",
                            fileType: (fileList) =>
                              !fileList[0] ||
                              [
                                "image/jpeg",
                                "image/png",
                                "image/gif",
                                "application/pdf",
                                "audio/mpeg",
                                "video/mp4",
                              ].includes(fileList[0].type) ||
                              "Unsupported file type",
                          },
                        })}
                        accept="image/jpeg,image/png,image/gif,application/pdf,audio/mpeg,video/mp4"
                      />

                      {errors?.media_file && (
                        <Form.Text className="text-danger">
                          {errors?.media_file?.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <div className="send_btn_holder">
                      <Orange_Btn
                        btnText={"Quick Send"}
                        icon={faPaperPlane}
                        onClick={handleSubmit(sendMessage)}
                        //  onClick={
                        //   () => { setShow(true) }
                        //   }
                      />
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="common_white_card chat_holder">
                <div className="heading_div">
                  <p className="heading_text">
                    Received Messages(Show Latest 10 Messages)
                  </p>
                </div>

                <div className="content_div">
                  <div className="messages_holder">
                    {report?.data?.length > 0 ? (
                      report.data.map((item) => (
                        <div key={item.id} className="message_div">
                          <div className="left_side">
                            <p className="black_txt">{item?.name}</p>
                            <p className="msg_txt">{item?.message || ""}</p>
                            <p className="black_txt">
                              {formatDate(item?.createdAt, true)}
                            </p>
                          </div>
                          <div className="btn_div">
                            <Orange_Btn
                              btnText="Reply"
                              onClick={() => {
                                setshowModal(true);
                                setMessage(item);
                              }}
                            />
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="no_data_text">No Data available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="count_cards_holder">
            <div className="row">
              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img1.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Instance Status</p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.active_instances} /{" "}
                      {dashInfo?.all_dashboard?.total_instances} Active
                      Instances
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xxl-4 col-lg-6 mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img2.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Total Send Messages</p>
                    <div className="status_divs">
                      <div className="colored_box green">
                        <p className="tag">Sent</p>
                        <p className="msg_count">
                          {dashInfo?.all_dashboard?.sent_message || 0}
                        </p>
                      </div>

                      {/* <div className="colored_box yellow">
                        <p className="tag">Paused</p>
                        <p className="msg_count">{dashInfo?.all_dashboard?.pause_message || 0}</p>
                      </div> */}

                      <div className="colored_box orange">
                        <p className="tag">Pending</p>
                        <p className="msg_count">
                          {dashInfo?.all_dashboard?.pending_message || 0}
                        </p>
                      </div>

                      <div className="colored_box red">
                        <p className="tag">Failed</p>
                        <p className="msg_count">
                          {dashInfo?.all_dashboard?.unsent_message || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img3.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Total Received Messages</p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.received_message || 0}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img4.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Auto Reply</p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.auto_replies || 0}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img5.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Messages Template</p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.total_templates || 0}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img6.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Send Message Count</p>
                    <button className="inactive_btn">
                      {user?.User_Subscription?.message_count || 0}{" "}
                      {user?.User_Subscription?.message_count === 1
                        ? "message can be sent"
                        : "messages can be sent"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="common_white_card black_heading_card">
            <div className="heading_div">
              <p className="heading_text">
                Read & Follow The Listed Conditions Carefully Before Using
                Whatsapp API.
              </p>
            </div>

            <div className="content_div">
              <p className="point_text">
                1) Login Your Whatsapp Only BETA Mode
              </p>
              <p className="point_text">
                2) Use Whatsapp API For Transaction/Notification/Chatbot.
              </p>
              <p className="point_text">
                3) Users Can Also Use Whatsapp API For Promotional Purpose But
                Its Can Lead Your Number Blocking Issue.
              </p>
              <p className="point_text">
                4) Welcome Message Use For Send Messages To New Whatsapp Users
                Who Text You First Time{" "}
              </p>
              <p className="point_text">
                5) User Can Send Welcome Message & Auto Reply Messages With
                Whatsapp Users Name By Add Variable %name%{" "}
                <span className="alert_text">
                  (Ex. Hello %name% How Are You)
                </span>
              </p>

              <p className="point_text">
                6) Name Variable <span className="alert_text">%name%</span> Only
                Works On Welcome Messages & Auto Reply Response
              </p>
              <p className="point_text">
                7) Will Suggest Users To Broadcast Messages With Buttons For Get
                Good Response
              </p>
              <p className="dark_point_text">
                8) Due To Certain Limitations From Whatsapp, When You Send
                Template message To Someone, The Message Won't Be Visible In You
                Phone. Also You Will Also See That The Message Has Been Sent Too
                Your Own Phone Number.
              </p>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="count_cards_holder">
            <div className="row">
              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img1.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Total Users</p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.total_users || 0}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img3.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">
                      Total Users Having Active Subscription
                    </p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.active_users || 0}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xxl-4 col-lg-6 mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img1.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">
                      Total Users Having Expired Subscription
                    </p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.inactive_users || 0}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xxl-4 col-lg-6 mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img2.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Todays Messages</p>
                    <div className="status_divs">
                      <div className="colored_box green">
                        <p className="tag">Sent</p>
                        <p className="msg_count">
                          {dashInfo?.all_dashboard?.todays_sent_message || 0}
                        </p>
                      </div>

                      {/* <div className="colored_box yellow">
                        <p className="tag">Paused</p>
                        <p className="msg_count">
                          {dashInfo?.all_dashboard?.todays_pause_message || 0}
                        </p>
                      </div> */}

                      <div className="colored_box orange">
                        <p className="tag">Pending</p>
                        <p className="msg_count">
                          {dashInfo?.all_dashboard?.todays_pending_message || 0}
                        </p>
                      </div>

                      <div className="colored_box red">
                        <p className="tag">Failed</p>
                        <p className="msg_count">
                          {dashInfo?.all_dashboard?.todays_unsent_message || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img5.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Connected Users</p>
                    <p className="count_text">
                      {dashInfo?.all_dashboard?.instance_connected || 0}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6  mb-3">
                <div className="count_card">
                  <div className="left_side">
                    <img
                      src="/Assets/Images/dashboard/img6.png"
                      className="icon_img"
                    />
                  </div>
                  <div className="right_side">
                    <p className="title_text">Disconnected Users</p>
                    <button className="inactive_btn">
                      {dashInfo?.all_dashboard?.instance_disconnected || 0}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <Reply_Modal
        show={showModal}
        showSuccess={showSuccess}
        setShowSuccess={setShowSuccess}
        setShowError={setShowError}
        message={message}
        setErrorMessage={setErrorMessage}
        onHide={() => {
          setshowModal(false);
        }}
      />

      <ModelLoader show={loader} setShow={setLoader} title={title} />

      {showSuccess && (
        <SuccessModel show={showSuccess} setShow={setShowSuccess} />
      )}
      {showError && (
        <ErrorModel
          show={showError}
          setShow={setShowError}
          name={errorMessage}
        />
      )}
    </section>
  );
};

export default Dashboard;
